import { render } from "./ModalPopup.vue?vue&type=template&id=32896c55"
import script from "./ModalPopup.vue?vue&type=script&lang=js"
export * from "./ModalPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__